import React, { useEffect, useState } from "react";
import {
  Typography,
  Row,
  Col,
  Breadcrumb,
  Space,
  Button,
  Dropdown,
  message,
  Card,
  Input,
  Collapse,
  Checkbox,
  Divider,
  Pagination,
  Select,
  Image,
} from "antd";
import { AppFooter } from "../LandingPage/Components/Footer/Footer";
import LogoGallery from "../LandingPage/Components/Logo/Logos";
import { useNotification } from "~/Hooks/useNotification";
import axios from "axios";
import type { MenuProps } from "antd";
import type { PaginationProps } from "antd";
import InvestImg from "@assets/KPMG/Invest.png";
import {
  HomeOutlined,
  DownOutlined,
  PercentageOutlined,
  StarOutlined,
  EnvironmentOutlined,
  PlusOutlined,
  MinusOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import MainHeader from "../../Components/MainHeader/MainHeader";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { InvestmentHubData } from "~/mocks/MockData";
import DjuandaWater from "@assets/KPMG/assets/DjuandaWater.png";
import BinhDuong from "@assets/KPMG/assets/BinhDuong.png";
import plant from "@assets/KPMG/assets/plant.png";
import reserve from "@assets/KPMG/assets/reserve.png";
import ConnectingDots from "@assets/KPMG/connectingDots.svg";
import CircleInCircle from "@assets/KPMG/circleInCircle.svg";
import { Icon } from "@iconify/react";
import styles from "./InvestmentHub.module.scss";
import { Fade } from "react-awesome-reveal";
import { ProjectsCard } from "~/Components/ProjectsCard/ProjectsCard";
import { useMaskId } from "~/Hooks/useMaskId";
import { NoData } from "../InfratechMarketPlace/Components/NoData";

const getRandomImage = () => {
  const images = [DjuandaWater, BinhDuong, plant, reserve];
  const randomIndex = Math.floor(Math.random() * images.length);
  return images[randomIndex];
};

const { Search } = Input;
const { Panel } = Collapse;
export const InvestmentHub: React.FC = () => {
  const { openToast } = useNotification();
  const [data, setData] = useState<any>([]);
  const [filteredData, setFilteredData] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(9);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedStages, setSelectedStages] = useState<string[]>([]);
  const [selectedAreas, setSelectedAreas] = useState<string[]>([]);
  const [selectedRatings, setSelectedRatings] = useState<any[]>([]);
  const [selectedSource,setSelectedSource] = useState<any[]>([]);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const param = searchParams.get("q");
  const countryParam = searchParams.get("country");
  const sectorParam = searchParams.get("sector");
  const { unmask } = useMaskId();
  const sectorList: any = [
    "Utility",
    "Energy",
    "Transportation",
    "Built Environment",
    "Social Infrastructure",
    "Digital Infrastructure",
  ];
  const subSector: any = {
    Utility: ["Water", "Waste", "Other"],
    Energy: [
      "Waste to Energy",
      "Solar",
      "Wind",
      "Hydropower",
      "Natural Gas",
      "Hydrogen",
      "Other",
    ],
    "Built Environment": ["Smart City", "Other"],
    Transportation: [
      "Expressway",
      "Railways",
      "Ports",
      "Airports",
      "Bus",
      "Logistics",
      "Other",
    ],
    "Social Infrastructure": ["Hospital", "School","Other"],
    "Digital Infrastructure": ["Data Centres", "Telecommunications"],
  };
  const [selectedSubSector, setSelectedSubSector] = useState<any>({
    Utility: [],
    Energy: [],
    "Built Environment": [],
    Transportation: [],
    "Social Infrastructure": [],
    "Digital Infrastructure":[],
  });
  const stageList: any = [
    "Capital Raising",
    "Early-stage",
    "Financial closed",
    "Planning",
    "Procurement",
  ];
  const areaList: any = [
    "Bangladesh",
    "Cambodia",
    "Indonesia",
    "Nepal",
    "Philippine",
    "Singapore",
    "Thailand",
    "Timor - Leste",
    "Vietnam",
  ];

  const ratingList: any = [
    {
      min: 80,
      max: 100,
      display: "80 - 100",
    },
    {
      min: 50,
      max: 80,
      display: "50 - 80",
    },
    {
      min: 0,
      max: 50,
      display: "<50",
    },
  ];
  const source: any = [
    "KPMG Intelligence",
    "External Sources"
  ]

  useEffect(() => {
    if (!countryParam && !sectorParam) {
      updateFilterData({ ...selectedSubSector }, [], [], [], selectedSource);
    }
  }, []);
  useEffect(() => {
    if (countryParam) {
      setSelectedAreas([countryParam]);
      updateFilterData({ ...selectedSubSector }, [countryParam], [], [], selectedSource);
    }
  }, [countryParam]);

  useEffect(() => {
    if (sectorParam) {
      let selectedSubSec: any = { ...selectedSubSector };
      selectedSubSec[sectorParam] = subSector[sectorParam];
      setSelectedSubSector(selectedSubSec);
      // setSelectedCategories([sectorParam]);
      updateFilterData(selectedSubSec, [], [], [],selectedSource);
    }
  }, [sectorParam]);

  useEffect(() => {
    getRecords();
  }, []);

  // useEffect(() => {
  //   console.log("filter data", filteredData);
  // }, [filteredData]);

  const handlePageChange = (page: number, pageSize?: number) => {
    setCurrentPage(page);
    setPageSize(pageSize || 9);
  };

  const getRecords = async () => {
    setData(InvestmentHubData);
  };
  const leadingBanks = (
    <Typography.Title level={5}>Leading Banks</Typography.Title>
  );

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    console.log("click", e);
  };

  const updateSubSector = (newSubSector: any) => {
    updateFilterData(
      newSubSector,
      selectedAreas,
      selectedRatings,
      selectedStages,
      selectedSource,
    );
  };

  const updateArea = (area: string) => {
    let temp = [...selectedAreas];
    if (temp.includes(area)) {
      temp = temp.filter((cat) => cat !== area);
    } else {
      temp = [...temp, area];
    }
    setSelectedAreas(temp);
    updateFilterData(selectedSubSector, temp, selectedRatings, selectedStages, selectedSource);
  };

  const updateRating = (rating: string) => {
    let temp = [...selectedRatings];
    if (temp.includes(rating)) {
      temp = temp.filter((cat) => cat !== rating);
    } else {
      temp = [...temp, rating];
    }
    setSelectedRatings(temp);
    updateFilterData(selectedSubSector, selectedAreas, temp, selectedStages, selectedSource);
  };

  const updateStage = (stage: string) => {
    let temp = [...selectedStages];
    if (temp.includes(stage)) {
      temp = temp.filter((cat) => cat !== stage);
    } else {
      temp = [...temp, stage];
    }
    setSelectedStages(temp);
    updateFilterData(selectedSubSector, selectedAreas, selectedRatings, temp, selectedSource);
  };

  const updateSource = (source: string) => {
    let temp = [...selectedSource];
    if (temp.includes(source)) {
      temp = temp.filter((src) => src !== source);
    } else {
      temp = [...temp, source];
    }
    setSelectedSource(temp);
    updateFilterData(selectedSubSector, selectedAreas, selectedRatings, selectedStages, temp);
  };

  const updateFilterData = (
    subSectors: any,
    areas: any,
    ratings: any,
    stages: any,
    sources: any
  ) => {
    let tempData = [...InvestmentHubData];
    if (
      subSectors[sectorList[0]].length > 0 ||
      subSectors[sectorList[1]].length > 0 ||
      subSectors[sectorList[2]].length > 0 ||
      subSectors[sectorList[3]].length > 0 ||
      subSectors[sectorList[4]].length > 0 ||
      subSectors[sectorList[5]].length > 0
    ) {
      tempData = tempData.filter(
        (item: any) => {
          let sectorName = item.categories[0].name;
          let subSectorName = item.categories[0].subcategories[0];
          // return (
          //   subSectors[sectorName] &&
          //   subSectors[sectorName].includes(subSectorName)
          // );
          let subSectorArrayWithoutOther = subSector[sectorName].filter(
            (item: string) => item !== "Other"
          );
          if (subSectors[sectorName].includes(subSectorName)) {
            return true;
          } else if (
            subSectors[sectorName].includes("Other") &&
            !subSectorArrayWithoutOther.includes(subSectorName)
          ) {
            return true;
          }
          return false;
        }
        // sectors.includes(item.categories[0].name)
      );
    }
    if (areas.length > 0) {
      // if (!areas.includes("ASEAN")) {
      tempData = tempData.filter((item: any) => areas.includes(item.Location));
      // }
    }

    if (ratings.length > 0) {
      let filteredRatingData = [...tempData];
      let newData: any = [];
      ratings.map((rating: string) => {
        let ratingObj = ratingList.find((item: any) => item.display === rating);
        filteredRatingData.map((item: any) => {
          let ratingNo = Number(item.InvestableRating);
          if (ratingNo > ratingObj.min && ratingNo <= ratingObj.max) {
            newData.push(item.key);
          }
        });
      });
      tempData = tempData.filter((item: any) => newData.includes(item.key));
    }

    if (stages.length > 0) {
      tempData = tempData.filter((item: any) =>
        stages.includes(item.ProjectStage)
      );
    }

    if (sources.length > 0) {
      if (sources.includes("KPMG Intelligence")) {
        tempData = tempData.filter((item: any) => item.source === "KPMG Intelligence");
      } else if (sources.includes("External Sources")) {
        tempData = tempData.filter((item: any) => item.source !== "KPMG Intelligence");
      }
    }
    setFilteredData(tempData);
  };

  const items: MenuProps["items"] = [
    {
      label: "1st menu item",
      key: "1",
    },
    {
      label: "2nd menu item",
      key: "2",
    },
    {
      label: "3rd menu item",
      key: "3",
    },
    {
      label: "4rd menu item",
      key: "4",
    },
  ];

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const onSearch = (value: string) => {
    // let tempData = [...filteredData];
    // tempData = tempData.filter(
    //   (item) =>
    //     // item.categories[0].name.includes(value) ||
    //     // item.Location.includes(value) ||
    //     item.title && item.title.includes(value)
    //   // item.ProjectStage.includes(value) ||
    //   // item.TechInvolved.includes(value) ||
    //   // item.categories[0].subcategories[0].includes(value)
    // );
    // console.log("temp data", tempData, value);
    // setFilteredData(tempData);
  };

  const panelStyle = {
    marginBottom: 24,
    border: "none",
  };

  return (
    <>
      <MainHeader
        title={"DECARB PROJECTS HUB"}
        imageSrc={InvestImg}
        text={
          "A hub to support and engage investors and infra owners/developers across sectors to access impact funds digitally. The Decarb Projects Hub will offer investors access to project data and generate investible project names."
        }
      />
      <Row justify="center" style={{ backgroundColor: "#fff" }}>
        <Col lg={18} style={{ margin: "1.5rem 0 0 0" }} offset={2}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Icon
                icon="ic:outline-home"
                height="20"
                onClick={() => navigate("/")}
                style={{
                  margin: "auto",
                  color: styles.strawberry,
                  cursor: "pointer",
                }}
              />
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <a onClick={() => navigate("/investment-hub")}>Decarb Projects Hub</a>
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col lg={18} style={{ padding: "20px 0" }}>
          <Row gutter={16}>
            <Col lg={6}>
              <div className="listview-input">
                <Input
                  placeholder="Search"
                  style={{ width: "95%", borderRadius: "0.5rem" }}
                  onChange={(e) => {
                    onSearch(e.target.value);
                  }}
                />
                <div>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={[
                      "source",
                      "area",
                      "sector",
                      "stage",
                      "investable-rating",
                      
                    ]}
                    expandIcon={({ isActive }) =>
                      isActive ? <MinusOutlined /> : <PlusOutlined />
                    }
                    expandIconPosition="end"
                    style={{ background: "#fff" }}
                  >
                     <Panel header={"Source"} key={"source"}>
                        {source.map((src: string, srcIndex: number) => (
                          <div key={`source-${srcIndex}`}>
                            <Checkbox
                              checked={selectedSource.includes(src)}
                              onChange={() => updateSource(src)}
                            >
                              {src}
                            </Checkbox>
                          </div>
                        ))}
                      </Panel>
                    <Panel header={"Sector"} key={"sector"}>
                      {sectorList.map((sector: any, secIndex: number) => (
                        <div key={`sector-${secIndex}`}>
                          <Checkbox
                            // checked={selectedCategories.includes(sector)}
                            checked={
                              selectedSubSector[sector].length ===
                              subSector[sector].length
                            }
                            indeterminate={
                              selectedSubSector[sector].length > 0 &&
                              selectedSubSector[sector].length <
                                subSector[sector].length
                            }
                            onChange={(e) => {
                              // updateSector(sector);
                              if (e.target.checked) {
                                let subSec = { ...selectedSubSector };
                                subSec[sector] = subSector[sector];
                                setSelectedSubSector(subSec);
                                updateSubSector(subSec);
                              } else {
                                let subSec = { ...selectedSubSector };
                                subSec[sector] = [];
                                setSelectedSubSector(subSec);
                                updateSubSector(subSec);
                              }
                            }}
                          >
                            {sector}
                            <div
                              className="nested-box"
                              style={{ paddingBottom: 10, display: "block" }}
                            >
                              {subSector[sector].map(
                                (subSector: string, subIndex: number) => (
                                  <Checkbox
                                    key={subIndex}
                                    checked={selectedSubSector[sector].includes(
                                      subSector
                                    )}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        let subSec = { ...selectedSubSector };
                                        let selectedSubSec = subSec[sector];
                                        selectedSubSec.push(subSector);
                                        subSec[sector] = selectedSubSec;
                                        setSelectedSubSector(subSec);
                                        updateSubSector(subSec);
                                      } else {
                                        let subSec = { ...selectedSubSector };
                                        let selectedSubSec = subSec[sector];
                                        selectedSubSec = selectedSubSec.filter(
                                          (item: string) => item !== subSector
                                        );
                                        subSec[sector] = selectedSubSec;
                                        setSelectedSubSector(subSec);
                                        updateSubSector(subSec);
                                      }
                                    }}
                                  >
                                    {subSector}
                                  </Checkbox>
                                )
                              )}
                            </div>
                          </Checkbox>
                        </div>
                      ))}
                    </Panel>
                    <Panel header={"Area"} key={"area"}>
                      {areaList.map((area: any, aIndex: number) => (
                        <div key={`area-${aIndex}`}>
                          <Checkbox
                            checked={selectedAreas.includes(area)}
                            onChange={() => updateArea(area)}
                          >
                            {area}
                          </Checkbox>
                        </div>
                      ))}
                    </Panel>
                    <Panel
                      header={"Investable Rating"}
                      key={"investable-rating"}
                    >
                      {ratingList.map((rating: any, rIndex: number) => (
                        <div key={`rating-${rIndex}`}>
                          <Checkbox
                            checked={selectedRatings.includes(rating.display)}
                            onChange={() => updateRating(rating.display)}
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <div>
                                <Icon
                                  icon={"ic:outline-star-border"}
                                  fontSize={15}
                                  color="#003087"
                                />
                              </div>
                              <div style={{ paddingLeft: 4 }}>
                                {rating.display}
                              </div>
                            </div>
                          </Checkbox>
                        </div>
                      ))}
                    </Panel>
                    <Panel header={"Stage/Type"} key={"stage"}>
                      {stageList.map((stage: any, stageIndex: number) => (
                        <div key={`stage-${stageIndex}`}>
                          <Checkbox
                            checked={selectedStages.includes(stage)}
                            onChange={() => updateStage(stage)}
                          >
                            {stage}
                          </Checkbox>
                          {stage === "Capital Raising" && <div style={{ height: "20px" }} />}
                        </div>
                      ))}
                    </Panel>
                   
                  </Collapse>
                </div>
              </div>
            </Col>
            <Col lg={18}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography.Title level={4}>Projects</Typography.Title>
                {/* <Space className="invest-sort-button">
                  Sort By
                  <Dropdown menu={menuProps}>
                    <Button>
                      <Space>
                        Location &nbsp;&nbsp;
                        <DownOutlined />
                      </Space>
                    </Button>
                  </Dropdown>
                </Space> */}
              </div>
              {filteredData.length === 0 && (
                <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
                  <Col span={24}>
                    <NoData />
                  </Col>
                </Row>
              )}
              {filteredData && filteredData.length > 0 && (
                <Row gutter={[16, 16]}>
                  {filteredData
                    .slice((currentPage - 1) * pageSize, currentPage * pageSize)
                    .map((data: any, i: number) => (
                      <Col
                        lg={8}
                        style={{ margin: "0.9rem 0" }}
                        key={`record-${i}`}
                      >
                        <ProjectsCard data={data} index={i} color />
                      </Col>
                    ))}
                  <Col lg={24} className="invest-sort">
                    <Row justify="space-between">
                      <Col className="first-col">
                        {/* <Space>
                        <Typography.Text>sort</Typography.Text>
                        <Select
                          defaultValue="1"
                          style={{ width: 50 }}
                          onChange={(e) => setSelectData(e)}
                          options={[
                            { value: "1", label: "1" },
                            { value: "2", label: "2" },
                            { value: "3", label: "3" },
                          ]}
                        />
                        <Typography.Text>Products per Page</Typography.Text>
                      </Space> */}
                      </Col>
                      <Col>
                        <Pagination
                          current={currentPage}
                          pageSize={pageSize}
                          total={filteredData.length}
                          onChange={handlePageChange}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <LogoGallery element={leadingBanks} />
      <AppFooter />
    </>
  );
};
